import React, { FC } from 'react';

import useContactEdit from './contact-edit-hook';
import ContactEditScene from './contact-edit-scene';

const UserEdit: FC = () => {
  const {
    t,
    _id,
    methods,
    history,
    errors,
    loading,
    modalInvite,
    setModalInvite,
    deleteUser,
    deleteParty,
    isDeletingParty,
    confirmModalOpen,
    setConfirmModalOpen,
    createUserMutation,
    setErrors,
    modalCreateMemberOpen,
    setModalCreateMemberOpen,
    getPartyResponse,
  } = useContactEdit();

  const handleUnlink = (id: string) => deleteUser({ id });

  // The confirm dialog stays locked while deleting; success navigates away, failure closes it.
  const handleDelete = () => {
    deleteParty({ id: _id }, { onError: () => setConfirmModalOpen({ state: false, kind: 'delete' }) });
  };

  const handleOpenInviteUser = (state: boolean) => setModalInvite(state);

  const handleCreateLoginEmail = (email: string, onClose: () => void) => {
    createUserMutation({
      id: methods.getValues('_id'),
      username: email
    });

    onClose();
  };

  const handleNavigateBack = () => history.goBack();

  const handleOpenConfirmModal = (state: boolean, kind: 'delete' | 'unlink') => {
    setConfirmModalOpen({ state, kind });
  };

  return (
    <ContactEditScene
      t={t}
      methods={methods}
      loading={loading}
      isDeletingParty={isDeletingParty}
      errors={errors}
      modalInvite={modalInvite}
      confirmModalOpen={confirmModalOpen}
      handleUnlink={handleUnlink}
      handleDelete={handleDelete}
      handleCreateLoginEmail={handleCreateLoginEmail}
      handleOpenInviteUser={handleOpenInviteUser}
      handleNavigateBack={handleNavigateBack}
      handleOpenConfirmModal={handleOpenConfirmModal}
      setErrors={setErrors}
      modalCreateMemberOpen={modalCreateMemberOpen}
      setModalCreateMemberOpen={setModalCreateMemberOpen}
      getPartyResponse={getPartyResponse}
    />
  );
};

export default UserEdit;
